import { OrderTypeEnum } from '@modules/orders-module/enums/order-type.enum'

export const OrderTypes: OrderTypeEnum[] = [
	OrderTypeEnum.MARKET,
	OrderTypeEnum.LIMIT,
	OrderTypeEnum.STOP,
	OrderTypeEnum.STOP_LIMIT,
	OrderTypeEnum.TRAILING_STOP,
]
